import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Learning",
  "lead": "في ما لا يقل عن 15 دولة في منطقة أفريقيا جنوب الصحراء الكبرى، يعجز أكثر من نصف الطلاب عن تحقيق المستوى الأدنى من إجادة القراءة بنهاية مرحلة التعليم الابتدائي."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_LEARNING"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "التحاق الأطفال بالمدارس ليس كافيًا. دون الانتقاص من الأغراض الأخرى العديدة الجديرة بالاهتمام التي تضطلع بها المدارس، والتي يجب أن تواصل السعي نحو تحقيقها، يجب أن يتمكن الطلاب من القراءة وإجراء العمليات الحسابية الأساسية. وتشكل هذه المهارات الأساس لأشكال التعلم الأخرى، ولتمكين الأفراد ورفاههم، وكذلك لتحقيق نتائج اجتماعية وسياسية واقتصادية."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "الأطفال-والشباب",
      children: "الأطفال والشباب"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1a",
      children: [_jsxs(_components.p, {
        children: ["يفتقر العديد من الأطفال في بعض من أفقر دول العالم إلى المهارات الأساسية في القراءة والرياضيات.\nوتشير تقييمات القراءة في الصفوف الدراسية الأولى في الولايات الشمالية في نيجيريا، مثل كادونا وسوكوتو، وفي مقاطعات جمهورية الكونغو الديمقراطية، مثل إكواتور وكاتانغا، على سبيل المثال، إلى أن أكثر من 80% من طلاب الصف الثالث في المدارس الابتدائية يعجزون عن قراءة حتى ", _jsx(_components.strong, {
          children: "كلمة واحدة"
        }), " من نص متصل."]
      }), _jsx(Figure, {
        id: "EGRA"
      })]
    }), "\n", _jsx(_components.p, {
      children: "لا تشمل هذه البيانات الأطفال غير الملتحقين بالمدارس. ويمكن أن تساعد المسوح التي تُجرى في المنازل على رصد مهارات الأطفال الذين يرتادون المدرسة والذين لا يرتادونها."
    }), "\n", _jsx(_components.p, {
      children: "على سبيل المثال، تتناول الرسوم البيانية أدناه مناطق مختلفة في باكستان والمناطق الريفية في الهند، استنادًا إلى تقييمات أجراها المواطنون."
    }), "\n", _jsxs(_components.p, {
      children: ["تُظهر ", _jsx(HighlightByIndex, {
        index: "1",
        children: "الخطوط الحمراء"
      }), " نسبة الأطفال ", _jsx(_components.strong, {
        children: "في المدرسة"
      }), " الذين يمتلكون مهارات القراءة الأساسية حسب الصف، بينما تُظهر ", _jsx(HighlightByIndex, {
        index: "0",
        children: "الخطوط الزرقاء"
      }), " نسبة الأطفال الذين يمتلكون مهارات القراءة الأساسية، ", _jsx(_components.strong, {
        children: "سواء كانوا في المدرسة أم لا، حسب العمر الذي يتوافق مع صفهم الدراسي"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "وتشكل الفجوات بين الخطين تذكيرًا بأن مقرري السياسات في البلدان التي ترتفع فيها معدلات غير الملتحقين بالمدارس لا يحصلون إلا على صورة جزئية فقط إذا اكتفوا برصد تعلم الطلاب في المدارس. وتجدر الإشارة إلى أن مستوى المهارة الذي يتم رصده هو مستوى منخفض للغاية. حتى في المناطق الأفضل أداءً، لا يستطيع بعض المراهقين على الأقل في المدارس الثانوية قراءة نص مخصص للصف الثاني."
    }), "\n", _jsx(Figure, {
      id: "LEARN_AGE_GRADE"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1b",
      children: _jsx(_components.p, {
        children: "تشير التقديرات إلى أن ما يقرب من 40% من الأطفال في سن التعليم الابتدائي لا يمتلكون مهارات القراءة الأساسية. وتصل هذه النسبة إلى 70% من الأطفال في منطقة أفريقيا جنوب الصحراء الكبرى، مقابل 3% فقط من الأطفال في أوروبا وأمريكا الشمالية."
      })
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.0",
      label: "4.1.0",
      children: [_jsx(_components.p, {
        children: "في العديد من البلدان، لا يوجد ما يضمن أن الأطفال سيكون بمقدورهم القراءة، حتى وإن أكملوا الدراسة الابتدائية. وعلى الصعيد العالمي، من بين الذين أكملوا تعليمهم الابتدائي، لم تكن لدى أربعة من كل عشرة منهم مهارات القراءة الأساسية. وترتفع هذه النسبة إلى 8 من كل عشرة في البلدان المنخفضة الدخل، كما يوضح الرسم البياني أدناه."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "LEARN_REACHFINAL"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["تُظهر ", _jsx(HighlightByIndex, {
              index: "-1",
              children: "الأجزاء الرمادية"
            }), " نسبة الأطفال الذين يكملون التعليم الابتدائي، ولكنهم لا يحققون المستوى الأدنى من إتقان القراءة. تُظهر ", _jsx(HighlightByIndex, {
              index: "1",
              children: "الأجزاء الحمراء"
            }), " الطلاب الذين يكملون التعليم الابتدائي ويحققون المستوى الأدنى من الإتقان، وتُظهر ", _jsx(HighlightByIndex, {
              index: "0",
              children: "الأجزاء الزرقاء"
            }), " الأطفال الذين لا يكملون التعليم الابتدائي."]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "عند النظر إلى مستوى الدول، في تشاد ونيجيريا، فإن نحو 90% من الشباب الذين تركوا المدرسة بعد 5 أو 6 سنوات لم يكونوا قادرين على القراءة والكتابة. ومع ذلك، توجد بعض البلدان التي تحقق معدلات أفضل بكثير. على سبيل المثال، كان تقريبًا جميع الذين تركوا المدرسة بعد الصف الخامس أو السادس في بوروندي وكوستاريكا وهندوراس قادرين على القراءة والكتابة."
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "LITBYYRS"
        })
      }), _jsx(ScrollySection, {
        id: "KEN",
        children: _jsxs(_components.p, {
          children: ["في ", _jsx(_components.strong, {
            children: "كينيا"
          }), "، على سبيل المثال، واحد من كل أربعة أشخاص لديهم القدرة على القراءة والكتابة ", _jsx(HighlightByIndex, {
            index: "1",
            children: "بعد ما يصل إلى 4 سنوات من الدراسة"
          }), "، لكن هذه النسبة ترتفع إلى ثلاثة من كل أربعة أشخاص لمن أكملوا ", _jsx(HighlightByIndex, {
            index: "0",
            children: "‏5-6 سنوات من الدراسة"
          }), " – أي ما يعادل إتمام التعليم الابتدائي."]
        })
      }), _jsx(ScrollySection, {
        id: "BFA",
        children: _jsxs(_components.p, {
          children: ["في ", _jsx(_components.strong, {
            children: "بوركينا فاسو"
          }), "، لا يظهر أي طفل تقريبًا ", _jsx(HighlightByIndex, {
            index: "1",
            children: "بعد 4 سنوات من الدراسة"
          }), " قادرًا على القراءة، ولكن أكثر من نصف الأطفال يكتسبون مهارات القراءة والكتابة الأساسية إذا أكملوا ", _jsx(HighlightByIndex, {
            index: "0",
            children: "مرحلة التعليم الابتدائي كاملة"
          }), "."]
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "لكي نتمكن من مقارنة التعلم بين البلدان، يجب مطابقة التقييمات أو الاختبارات مع المعايير الدولية باستخدام تعريف واحد مشترك. وقد تم مؤخرًا وضع مثل هذه المعايير للتقييمات الدولية؛ إذ يخضع الطلاب من عدة بلدان لنفس الاختبار. ولكن لا يتوفر حتى الآن إلا عدد قليل من هذه المخططات للتقييمات الوطنية."
    }), "\n", _jsx(_components.p, {
      children: "يُجرى تقييم واحد، وهو دراسة اتجاهات التحصيل في الرياضيات والعلوم على الصعيد الدولي (TIMSS)، كل أربع سنوات، ويتيح لنا متابعة التقدم المحرز مع مرور الوقت بين طلاب الصف الرابع والصف الثامن. ويوضح هذا التقييم الأماكن التي كان التقدم فيها بطيئًا بشكل خاص. على سبيل المثال، في مصر، ارتفعت نسبة طلاب الصف الثامن الذين حققوا الحد الأدنى من الكفاءة في الرياضيات من 24% في عام 2003 إلى 27% فقط في عام 2019."
    }), "\n", _jsxs(_components.p, {
      children: ["شهدت بعض البلدان، مثل ", _jsx(HighlightByIndex, {
        index: "0",
        children: "ماليزيا"
      }), "، انخفاضًا في نسبة الطلاب الذين يحققون الحد الأدنى من مستويات التعلم مع مرور الوقت."]
    }), "\n", _jsxs(_components.p, {
      children: ["وفي بلدان أخرى، مثل ", _jsx(HighlightByIndex, {
        index: "1",
        children: "البحرين"
      }), "، كان التقدم سريعًا – حيث تضاعفت نسبة الطلاب الذين حققوا الحد الأدنى من الكفاءة أكثر من ثلاث مرات بين عامَي 2003 و2019."]
    }), "\n", _jsx(Figure, {
      id: "PIRLSGAIN"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1b",
      children: [_jsx(_components.p, {
        children: "على عكس ما يتوقعه الكثيرون، فإن فجوات التعلم بين الجنسين ليست واسعة ــ إذ لا تتجاوز عشر نقاط مئوية في جميع بلدان العالم تقريبًا في التعليم الابتدائي، على سبيل المثال."
      }), _jsx(_components.p, {
        children: "بيد أن فجوات التعلم بين البلدان هائلة. في دول منطقة أفريقيا جنوب الصحراء الكبرى، التي عادةً ما تكون في أدنى مستويات مهارات القراءة في التعليم الابتدائي، تتراوح نسبة الطلاب الذين يحققون الحد الأدنى من الكفاءة من 4% فقط في بوروندي إلى 76% في الغابون (وكلتا النتيجتين من برنامج تحليل النظم التعليمية في بلدان مؤتمر وزراء التربية للبلدان التي يجمع بينها استخدام اللغة الفرنسية PASEC 2019)."
      }), _jsx(_components.p, {
        children: "وفي مادة الرياضيات في التعليم الابتدائي في دول جنوب شرق آسيا، تتراوح المعدلات من 8% فقط في جمهورية لاو الديمقراطية الشعبية إلى 91% في فيتنام (كلتا النتيجتين من مقاييس التعلم الابتدائي في جنوب شرق آسيا SEA-PLM 2019)."
      }), _jsx(Figure, {
        id: "ASSESS"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "البالغون",
      children: "البالغون"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.6.2",
      children: [_jsx(_components.p, {
        children: "بين عامَي 2000 و2023، ارتفعت نسبة البالغين القادرين على القراءة والكتابة من 81% إلى 87% على مستوى العالم، في حين ارتفعت نسبة الشباب القادرين على القراءة والكتابة من 87% إلى 93%."
      }), _jsx(_components.p, {
        children: "ورغم هذه التطورات، لا تزال الأمية منتشرة على نطاق واسع في العديد من البلدان، لا سيما بين النساء. وفي أمريكا اللاتينية ومنطقة البحر الكاريبي، يعكس التقدم المتوقف عند مستويات مرتفعة نسبيًا وجود جماعات صغيرة من الفئات المحرومة بشدة التي \"يصعب الوصول إليها\". وفي الإكوادور، على سبيل المثال، لم يتغير معدل معرفة القراءة والكتابة بين النساء البالغات في المناطق الريفية كثيرًا خلال السنوات العشر الماضية؛ إذ ظل عند نحو 83%."
      }), _jsx(_components.p, {
        children: "في منطقة أفريقيا جنوب الصحراء الكبرى، لا تستطيع أكثر من 40% من النساء البالغات (في الفئة العمرية 25-64 عامًا) القراءة. وفي العديد من البلدان، توقف التقدم عند مستويات منخفضة للغاية، كما هو الحال في مالي؛ حيث لا يستطيع القراءة سوى أقل من 17%، أو كان التقدم بطيئًا، كما هو الحال في جمهورية تنزانيا المتحدة، التي شهدت تحسنًا من 72% إلى 77% على مدى عشر سنوات."
      }), _jsx(_components.p, {
        children: "على الصعيد العالمي، إذا كان عدد البالغين القادرين على القراءة والكتابة قد ازداد اليوم مقارنة بالماضي، فإن ذلك يرجع في الغالب إلى أن المزيد من البالغين التحقوا بالمدارس عندما كانوا صغارًا، وليس لأن البالغين الذين لم يرتادوا المدرسة حصلوا على فرصة ثانية للتعلم. وللتحقق من هذا الادعاء، يوضح الرسم البياني أدناه بيانات تتبع مهارات القراءة والكتابة لدى فئة بعينها - أو مجموعة - مع تقدمها في العمر."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "LITCOHORT"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["في معظم البلدان، شهدت مستويات معرفة القراءة والكتابة بين ", _jsx(HighlightByIndex, {
              index: "0",
              children: "فئة معينة من البالغين"
            }), " توقفًا أو حتى تراجعًا مع مرور الوقت؛ بسبب قلة استخدام مهاراتهم."]
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["في ", _jsx(_components.strong, {
              children: "بوركينا فاسو"
            }), "، يوضح الخط الأزرق أن معدل معرفة القراءة والكتابة لدى ", _jsx(HighlightByIndex, {
              index: "0",
              children: "النساء اللاتي تتراوح أعمارهن بين 20 و34 عامًا في عام 2003"
            }), "، ", _jsx(HighlightByIndex, {
              index: "0",
              children: "وبين 27 و41 عامًا في عام 2010"
            }), "، ", _jsx(HighlightByIndex, {
              index: "0",
              children: "وبين 38 و62 عامًا في عام 2021"
            }), " ظل مستقرًا نسبيًا. ومع ذلك، بسبب زيادة عدد الشابات القادرات على القراءة والكتابة، فإن الخط الأحمر يوضح أن ", _jsx(HighlightByIndex, {
              index: "1",
              children: "معدل معرفة القراءة والكتابة بين النساء اللاتي تتراوح أعمارهن بين 20 و34 عامًا"
            }), " قد شهد زيادة مع مرور الوقت."]
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.6.1",
      children: [_jsx(_components.p, {
        children: "إن مهارات القراءة والكتابة التي تقيسها هذه التقييمات مهارات أساسية جدًا. فهي تظهر قدرة الأشخاص على قراءة جملة بسيطة. أما معرفة القراءة والكتابة الوظيفية، التي يتمكن الأشخاص عن طريقها من قراءة التعليمات المكتوبة، أو الرسائل الرسمية، أو العقود، وتفسيرها، فهو أمر مختلف."
      }), _jsx(_components.p, {
        children: "يُجرى عدد قليل من المسوح الدولية التي تجمع بيانات عن معرفة القراءة والكتابة الوظيفية، ناهيك عن جمعها بصفة دورية."
      }), _jsx(_components.p, {
        children: "ومن خلال البيانات المتوفرة لدينا، يمكننا أن نلاحظ أن أكثر من 1 من كل 10 بالغين في المناطق الحضرية في كولومبيا وفيتنام و1 من كل 4 في بوليفيا غير قادرين على القراءة الوظيفية (أي أنهم دون المستوى الأول من الكفاءة) في معرفة القراءة والكتابة الوظيفية."
      }), _jsxs(_components.p, {
        children: ["في ", _jsx(_components.strong, {
          children: "غانا"
        }), "، حتى بين البالغين في المناطق الحضرية، لا يمتلك سوى 39% منهم فقط مهارات القراءة والكتابة الوظيفية."]
      }), _jsx(Figure, {
        id: "LITPROF"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "خاتمة",
      children: "خاتمة"
    }), "\n", _jsx(_components.p, {
      children: "على الرغم من أن الهدف الرابع من أهداف التنمية المستدامة قد حول التركيز نحو رصد التعلم، غير أن العديد من البلدان لا تزال لا تقدم تقارير عن مؤشرات نتائج التعلم في القراءة والرياضيات. وحتى البلدان التي تريد البدء في تقييم التعلم وإعداد التقارير عنه، غالبًا ما تواجه عقبات تحول دون تبني حلول فعالة ومنخفضة التكلفة. ومع ذلك، تشير الأدلة المتوفرة لدينا إلى أن معظم الطلاب في أفقر بلدان العالم لا يحققون الحد الأدنى من الكفاءة في أكثر المهارات الأساسية."
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://openknowledge.worldbank.org/handle/10986/32553",
            children: "Ending learning poverty – what will it take? (القضاء على فقر التعلم – ما الذي يتطلبه الأمر؟) – البنك الدولي"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "http://uis.unesco.org/sites/default/files/documents/ip61-combining-data-out-of-school-children-completion-learning-offer-more-comprehensive-view-sdg4.pdf",
            children: "Combining Data on Out-of-School Children, Completion and Learning to Offer a More Comprehensive View on SDG 4 (دمج البيانات المتعلقة بالأطفال غير الملتحقين بالمدارس وإكمال التعليم والتعلم؛ لتقديم رؤية أكثر شمولًا للهدف الرابع من أهداف التنمية المستدامة - معهد اليونسكو للإحصاء"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://unesdoc.unesco.org/ark:/48223/pf0000225660",
            children: "EFA GMR 2013/4: Teaching and learning: Achieving quality for all (التقرير العالمي لرصد التعليم للجميع 2013/4: التعلم والتعليم: تحقيق الجودة للجميع)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://gemreportunesco.wordpress.com/2019/05/20/the-learning-assessment-market-pointers-for-countries-part-2/",
            children: "The learning assessment market - pointers for countries (سوق تقييم التعلم - مؤشرات للدول)"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
